import { render, staticRenderFns } from "./Simple150.vue?vue&type=template&id=27734a36&scoped=true&"
import script from "./Simple150.vue?vue&type=script&lang=js&"
export * from "./Simple150.vue?vue&type=script&lang=js&"
import style0 from "./Simple150.vue?vue&type=style&index=0&id=27734a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27734a36",
  null
  
)

export default component.exports